<template>
  <div class="relative mt-20 mb-20 max-w-screen-sm left-1/2 -translate-x-1/2">
    <div class="px-12">
      <h2>Forbidden</h2>
      <p>You're not authorised to see this page 😅</p>
      <button @click="goToLanding()">Home</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ForbiddenPage',
  data() {
    return {
    }
  },
  beforeMount() {
  },
  methods: {
    goToLanding() {
      this.$router.push('/onboarding/landing')
    },
  },
}
</script>